import instance from './axios';

export async function getHome(type: string) {
  try {
    const res = await instance.get(`/main/home/v3?t=${type}`, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return res.data;
  } catch (e) {
    console.log(`[GET_DETAILS_COLLECTION] Il y a eu un problème : ${e}`);
    return null;
  }
}
export async function getHomeCache(type: string) {
  try {
    const res = await instance.get(`/main/home/v3?t=test`, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return res.data;
  } catch (e) {
    console.log(`[GET_DETAILS_COLLECTION] Il y a eu un problème : ${e}`);
    return null;
  }
}

export async function getSerieInfo(idSerie: string | undefined) {
  try {
    const response = await instance.get(`/main/serie/${idSerie}`, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function getSerieInfoV2(idSerie: string | undefined) {
  try {
    const response = await instance.get(`/main/serie/v2/${idSerie}`, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function isEpLu(idEp: string | undefined) {
  try {
    const response = await instance.get(`/main/serie/v2/${idEp}/is/read`, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function isEpUnlock(idEp: string | undefined) {
  try {
    const response = await instance.get(`/main/serie/v2/${idEp}/is/unlock`, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function isAssign(idEp: string | undefined) {
  if (!idEp) return false;
  try {
    const response = await instance.get(`/main/serie/v2/${idEp}/is/assign`, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function addToReadingList(idSerie: number) {
  try {
    const res = await instance.post(
      `/main/home/list/add`,
      {
        idSerie,
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
    return res.data;
  } catch (e) {
    console.log(`[GET_DETAILS_COLLECTION] Il y a eu un problème : ${e}`);
    return null;
  }
}
